import { prop } from 'ramda';
import { urls } from '../../config.js';
import { translateHuggg } from '../../utils/huggg';

/**
 * Update a huggg with the provided data.
 *
 * huggg.update(axios, id, { notes: 'some notes' }).then( ... )
 * huggg.update(id, { notes: 'some notes' }).then( ... )
 *
 * @param {Object} [axios=axios] Axios instance.
 * @param {String} id Huggg ID.
 * @param {Object} data Columns to update
 * @throws {Error} If no huggg ID provided
 * @returns {Promise} Unresolved promise containing formatted data.
 */
var update = function update(axios, id, data) {
  if (!id) {
    throw new Error('Prop `id` is required in `huggg.update`');
  }
  return axios.patch(urls.apiV2("/hugggs/".concat(id)), data).then(prop('data')).then(function (_ref) {
    var data = _ref.data,
      embedded = _ref.embedded;
    return translateHuggg(data, embedded);
  });
};
export default update;